import styled from "styled-components";
import Device from "../../../../shared/components/global/Device/Device";
import StyledLink from "../../../../shared/components/global/StyledLink";
import { ButtonSizes, TextButton } from "../../../../shared/styles/button";
import { Stripe, Stripes } from '../../../../shared/styles/jobs/stripes';
import TalentpoolLogo from '/public/svg/Logo.svg';

interface ContainerProps {
    small: boolean;
}

const JobsHeroHeaderContainer = styled.div<ContainerProps>`
    position: relative;
    height: ${props => props.small ? '120px' : '360px'};
    width: 100%;
    overflow: hidden;
`

const JobsHeroTextBox = styled.div`
    position: relative;
    height: 100%;
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: auto;
    text-align: center;

    h1 {
        font-weight: 800;
        font-size: 40px;
        line-height: 45px;
        margin: 0;
    }
`

const JobLogo = styled.span`
    cursor: pointer;
    line-height: 30px;
    margin-bottom: 0;
    margin-right: 0;
    margin-top: 0;
    a {
        display: flex;
        align-items: center;
    }

    svg {
        height: 80px;
        width: 80px;
    }
`;

interface Props {
    small: boolean
}

export default function JobsHeroHeader({ small }: Props) {
    let stripedTop1 = '20px';

    return (
        <JobsHeroHeaderContainer small={small}>
            <Device>
                {({ isMobile }) =>
                    <Stripes left="0" right="unset" top={stripedTop1}>
                        <Stripe stripeColor="#FDC228" translateX={0} translateY={-50} />
                        <Stripe stripeColor="#FFEAB4" translateX={isMobile ? 100 : 500} translateY={-60} />
                        <Stripe stripeColor="#E5C570" translateX={isMobile ? 320 : 1350} translateY={-20} />
                    </Stripes>
                }
            </Device>
            {!small &&
                <JobsHeroTextBox>
                    <JobLogo>
                        <TalentpoolLogo />
                    </JobLogo>
                    <h1>Finde den Job,<br />den du liebst.</h1>
                    <StyledLink href="/jobs/company">
                        <TextButton primary size={ButtonSizes.m}>Jetzt Job ausschreiben</TextButton>
                    </StyledLink>
                </JobsHeroTextBox>
            }

        </JobsHeroHeaderContainer>
    )
}
